define([], () => {
    return ['$location', 'StateUtils', 'ModalService',
        ($location, StateUtils, ModalService) => ({
            handleStateChange(event, toState, fromState) {
                const flow = StateUtils.activeDataForState(true);
                if (flow && flow.flowModel) {
                    const flowModel = flow.flowModel;
                    const model = flow.model;
                    /**
                     * If browser navigation has been used, flowModel is not at the next step already
                     * So it needs to be synced manually
                     */
                    if (flowModel.currentStep.name === fromState.name && toState.name !== 'contactUs') {
                        const isBound = model.value.bindData && model.value.bindData.isBound;

                        if (isBound) {
                            /**
                             * if offer is bound, always go to last page (now it is /mfpConfirmation/)
                             */
                            flowModel.jumpToStep(flowModel.steps[flowModel.steps.length - 1].name, model, null, true);
                        } else {
                            const stepNames = flowModel.steps.map(step => step.name);
                            const nameFrom = fromState.name;
                            const nameTo = toState.name;
                            const fromStepIndex = stepNames.indexOf(nameFrom);

                            /**
                             * After retrieving a submission...
                             */
                            if (stepNames.indexOf(nameTo) < 0) {
                                /**
                                 * If step we want to go to, doesn't exist either go to previous page or
                                 * prevent navigation completely
                                 */
                                if (fromStepIndex > 0) {
                                    flowModel.jumpToStep(flowModel.steps[fromStepIndex - 1].name, model, null, true);
                                }
                                event.preventDefault();
                            } else if (stepNames.indexOf(nameTo) > fromStepIndex) {
                                /**
                                 * If we navigate forward, prevent because we can not guarantee
                                 * that the flow model state is valid
                                 */
                                event.preventDefault();
                                ModalService.showError(undefined, 'app.resubmit');
                            } else {
                                /**
                                 * On valid backward navigation, just synchronize flow model with step we jump back to
                                 */
                                flowModel.jumpToStep(toState.name, model, null, true);
                            }
                        }
                    }
                }
            },
        }),
    ];
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/baslercommon/services/BaslerBrowserNavigationService.js